import { render, staticRenderFns } from "./StepChoicesEditor.vue?vue&type=template&id=9dbe41c4&scoped=true"
import script from "./StepChoicesEditor.vue?vue&type=script&lang=js"
export * from "./StepChoicesEditor.vue?vue&type=script&lang=js"
import style0 from "./StepChoicesEditor.vue?vue&type=style&index=0&id=9dbe41c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbe41c4",
  null
  
)

export default component.exports